/** @jsx jsx */
import { Container, Flex, Heading, Box, Link, jsx } from 'theme-ui';
import _ from 'lodash';
import { GatsbyImage } from 'gatsby-plugin-image';
import Marquee from 'react-marquee-slider';
import RichTextRenderer from '~/components/Content/RichText';
import useWindowSize from '~/hooks/components/use-window-size';
import InnerCycle from '../../InnerCycle';

const ImageMarquee = ({ images, heading, hasLabels, offsetImages = false, spinner = false }) => {
  const { width } = useWindowSize();

  const imgArr = images.length < 7 ? [...images].concat(images) : images;

  return (
    <Container variant="fullwidth" sx={{ position: 'relative', mb: '70px', zIndex: 0 }}>
      <Flex sx={{ justifyContent: 'center', p: { mb: '0px' } }}>
        <Heading
          sx={{
            color: 'alizarinCrimson',
            fontWeight: 700,
            fontSize: [9, 12, 19],
            textTransform: 'uppercase',
            margin: 0,
            padding: 0,
            position: 'relative',
            maxWidth: ['50%', 'none'],
            textAlign: ['center', 'left'],
          }}
        >
          {spinner && (
            <InnerCycle
              sx={{
                position: 'absolute',
                width: ['78px', '90px', '136px'],
                height: ['78px', '90px', '136px'],
                left: ['-93px', '-120px', '-184px'],
                top: ['-10px', null, '-25px'],
                zIndex: 1,
              }}
            />
          )}
          {heading.raw ? <RichTextRenderer richText={heading} /> : heading}
        </Heading>
      </Flex>
      <Box
        sx={{
          height: [
            hasLabels ? '260px' : '207px',
            hasLabels ? '304px' : '242px',
            hasLabels ? '312px' : '247px',
          ],
          width: '100%',
          overflow: 'hidden',
          boxSizing: 'border-box',
          position: 'relative',
          margin: '0 auto',
          mt: '25px',
        }}
      >
        <Marquee velocity={width < 832 ? 10 : 30} minScale={1}>
          {_.map(imgArr, (image, idx) => {
            const offset = offsetImages && idx % 2 === 0;
            return (
              <Flex
                key={`community-image-${idx}`}
                sx={{
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: '0 25px',
                }}
              >
                {image.link ? (
                  <Link href={image.link}>
                    <Flex
                      sx={{
                        transform: offset ? 'translateY(-12px)' : null,
                        height: [offset ? '180px' : '200px', offset ? '218px' : '242px'],
                        width: [offset ? '180px' : '200px', offset ? '218px' : '242px'],
                        alignItems: 'center',
                        justifyContent: 'center',
                        '& > .gatsby-image-wrapper': {
                          height: '100%',
                          width: '100%',
                        },
                      }}
                    >
                      <GatsbyImage
                        id={`image-${image.link}-${idx}`}
                        image={image.gatsbyImageData}
                        alt={image.altText ?? ''}
                        imgStyle={{ objectFit: 'cover' }}
                      />
                    </Flex>
                  </Link>
                ) : (
                  <Flex
                    sx={{
                      transform: offset ? 'translateY(-12px)' : null,
                      height: [offset ? '180px' : '200px', offset ? '218px' : '242px'],
                      width: [offset ? '180px' : '200px', offset ? '218px' : '242px'],
                      alignItems: 'center',
                      justifyContent: 'center',
                      '& > .gatsby-image-wrapper': {
                        height: '100%',
                        width: '100%',
                      },
                    }}
                  >
                    <GatsbyImage
                      id={`image-${image.link}-${idx}`}
                      image={image.gatsbyImageData}
                      alt={image.altText ?? ''}
                    />
                  </Flex>
                )}

                {hasLabels && (
                  <Flex
                    sx={{
                      flexDirection: 'column',
                      alignItems: 'center',
                      mt: '12px',
                      '& > p': { margin: 0 },
                    }}
                  >
                    <RichTextRenderer richText={image.label} />
                  </Flex>
                )}
              </Flex>
            );
          })}
        </Marquee>
      </Box>
    </Container>
  );
};

export default ImageMarquee;
